/**
 * L8 flags — 코드 상수 플래그의 «기본값 장부»(순수 · 클라이언트에서도 import 가능). 서버 읽기는 lib/config/flags.ts.
 *   기본값 = 종전 코드값. 시드 SQL(supabase/migrations/20261105_l8_ops.sql · namespace 'flags')과 같은 값이어야 한다(시험이 대조).
 */
export const CODE_FLAG_DEFAULTS = {
  /** 카톡방 참여 인원 문구(「1,200+명이 」) 노출 — lib/talk-banner TALK_MEMBER_SHOW */
  talk_member_show: false,
  /** vx4 게시판 적재 지원 — lib/vx4/board-enqueue BOARD_SUPPORTED */
  board_supported: false,
  /** 리드폼 생년월일 필수 — lib/apt/lead-ink LEAD_BIRTH_REQUIRED */
  lead_birth_required: false,
  /** 상세 히어로 시간대 자동 전환 — lib/apt/detail-vx3 HERO_TIME_AUTO_SWITCH */
  hero_time_auto_switch: false,
  /** 단지 상세 교통·학교 섹션 숨김 — lib/detail-rich/complex/guards NEARBY_FACILITIES_HIDDEN */
  nearby_facilities_hidden: true,
  /** 종목 상세 수급 블록 노출 — app/(main)/stock/[symbol] FLOW_IS_MEASURED */
  flow_is_measured: false,
} as const;

export type CodeFlag = keyof typeof CODE_FLAG_DEFAULTS;
